import { AppMedlogicPwaCuidadoState } from '../states/app-state';


export const selectProcesses = (state: AppMedlogicPwaCuidadoState) => state.process.selectedProcess;

export const selectAllProcesses = (state: AppMedlogicPwaCuidadoState) => state.process.allProcesses;

